module.exports = __webpack_public_path__ + "media/images/Philip_Pallmann-4672e8a5c68d0135ec56867c706eb419.jpg";